import { render, staticRenderFns } from "./addModelNotation.vue?vue&type=template&id=49c9060f&scoped=true"
import script from "./addModelNotation.vue?vue&type=script&lang=js"
export * from "./addModelNotation.vue?vue&type=script&lang=js"
import style0 from "./addModelNotation.vue?vue&type=style&index=0&id=49c9060f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9060f",
  null
  
)

export default component.exports